/* Pure Lust — Vind jouw vibe quiz
 * 6-question state machine -> multi-signal product recommender.
 * Hero -> Q1-Q6 -> email gate -> results.
 *
 * The recommender does NOT pick a single "winner mood + 3 static products".
 * It builds a profile (mood vector + intensity, experience, company, tempo,
 * interests), scores every candidate slot from the relevant rituelen, gates on
 * experience, enforces category diversity, and renders ranked picks with a
 * personalised reason per pick. Catalog = pl-ritueel-config (single source).
 */
(function () {
  var MOODS = ['solo', 'samen', 'date', 'eerste', 'bdsm'];

  var MOOD_LABEL = {
    solo: 'Een avond met jezelf',
    samen: 'Samen genieten',
    date: 'Een date night',
    eerste: 'Net begonnen',
    bdsm: 'BDSM',
    anaal: 'Anaal verkennen'
  };

  // Which audience each mood implies (for company-fit scoring).
  var MOOD_AUDIENCE = {
    solo: ['solo'], eerste: ['solo'], samen: ['partner', 'group'],
    date: ['new', 'partner'], bdsm: ['partner'], anaal: ['solo', 'partner']
  };

  var INTEREST_LABEL = {
    sensory: 'zacht & sensueel', lingerie: 'lingerie & verleiding',
    bondage: 'touw & overgave', toys: 'speeltjes', anal: 'anaal verkennen'
  };

  var COMPANY_LABEL = {
    solo: 'jezelf', partner: 'jullie samen', group: 'meer mensen', new: 'iemand nieuws'
  };

  function init() {
    var root = document.querySelector('[data-pl-vibe]');
    if (!root) return;

    var catalog = parseCatalog(root);
    var emailGateOn = root.getAttribute('data-pl-email-gate') === 'on';

    var state = {
      scores: { solo: 0, samen: 0, date: 0, eerste: 0, bdsm: 0 },
      axisSum: { intensity: 0, experience: 0, tempo: 0 },
      axisCount: { intensity: 0, experience: 0, tempo: 0 },
      company: {},
      interest: {},
      answers: []
    };

    var startBtn = root.querySelector('[data-pl-vibe-start]');
    var heroPanel = root.querySelector('[data-pl-vibe-hero]');
    var quizPanel = root.querySelector('[data-pl-vibe-quiz]');
    var emailPanel = root.querySelector('[data-pl-vibe-email]');
    var resultsPanel = root.querySelector('[data-pl-vibe-results]');
    var questionPanels = root.querySelectorAll('[data-pl-question]');
    var progressDots = root.querySelectorAll('[data-pl-dot]');
    var skipBtn = root.querySelector('[data-pl-vibe-skip]');
    var emailForm = root.querySelector('[data-pl-vibe-email-form]');

    if (startBtn) {
      startBtn.addEventListener('click', function () {
        hide(heroPanel);
        show(quizPanel);
        goToQuestion(1);
        scrollToTop();
      });
    }

    var answerBtns = root.querySelectorAll('[data-pl-answer]');
    answerBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var qNum = parseInt(btn.getAttribute('data-q'), 10);
        applyScores(btn.getAttribute('data-scores'));
        applyAxis(btn.getAttribute('data-axis'));
        state.answers[qNum] = btn.getAttribute('data-label') || '';

        if (qNum < 6) {
          goToQuestion(qNum + 1);
        } else if (emailGateOn && emailPanel) {
          hide(quizPanel);
          show(emailPanel);
          scrollToTop();
        } else {
          showResults(); // gate disabled -> straight to picks
          return;
        }
        scrollToTop();
      });
    });

    if (skipBtn) {
      skipBtn.addEventListener('click', function (e) {
        e.preventDefault();
        showResults();
      });
    }

    if (emailForm) {
      emailForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var emailInput = emailForm.querySelector('input[type="email"]');
        var email = emailInput ? emailInput.value.trim() : '';
        if (email) {
          var fd = new FormData(emailForm);
          fetch('/contact', { method: 'POST', body: fd }).catch(function () {});
        }
        showResults();
      });
    }

    function applyScores(raw) {
      if (!raw) return;
      raw.split(',').forEach(function (pair) {
        var kv = pair.split(':');
        if (kv.length !== 2) return;
        var k = kv[0].trim(), v = parseInt(kv[1].trim(), 10);
        if (state.scores.hasOwnProperty(k) && !isNaN(v)) state.scores[k] += v;
      });
    }

    function applyAxis(raw) {
      if (!raw) return;
      raw.split(',').forEach(function (pair) {
        var kv = pair.split(':');
        if (kv.length !== 2) return;
        var k = kv[0].trim(), v = kv[1].trim();
        if (state.axisSum.hasOwnProperty(k)) {
          var n = parseInt(v, 10);
          if (!isNaN(n)) { state.axisSum[k] += n; state.axisCount[k] += 1; }
        } else if (k === 'company') {
          state.company[v] = (state.company[v] || 0) + 1;
        } else if (k === 'interest') {
          state.interest[v] = (state.interest[v] || 0) + 1;
        }
      });
    }

    function goToQuestion(n) {
      questionPanels.forEach(function (p) {
        var qn = parseInt(p.getAttribute('data-pl-question'), 10);
        if (qn === n) p.removeAttribute('hidden'); else p.setAttribute('hidden', '');
      });
      progressDots.forEach(function (d) {
        var dn = parseInt(d.getAttribute('data-pl-dot'), 10);
        if (dn <= n) d.classList.add('is-active'); else d.classList.remove('is-active');
      });
    }

    function buildProfile() {
      var avg = function (k, dflt) {
        return state.axisCount[k] ? state.axisSum[k] / state.axisCount[k] : dflt;
      };
      var topKey = function (obj) {
        var best = null, top = -1;
        Object.keys(obj).forEach(function (k) { if (obj[k] > top) { top = obj[k]; best = k; } });
        return best;
      };
      return {
        scores: state.scores,
        intensity: clamp(avg('intensity', 2), 0, 5),
        experience: clamp(avg('experience', 1), 0, 5),
        tempo: avg('tempo', 2),
        company: topKey(state.company) || 'solo',
        interest: state.interest
      };
    }

    function showResults() {
      var profile = buildProfile();
      var ranked = rankMoods(profile.scores);
      var primary = ranked[0] || 'solo';
      var secondary = (ranked[1] && profile.scores[ranked[1]] > 0) ? ranked[1] : null;

      var primInfo = catalog[primary] || catalog.solo;

      // Mood label + handoff page (primary ritueel).
      var labelEl = root.querySelector('[data-pl-mood-label]');
      if (labelEl) labelEl.textContent = MOOD_LABEL[primary] || primInfo.page;

      var subEl = root.querySelector('[data-pl-mood-sub]');
      if (subEl) {
        if (secondary) {
          subEl.textContent = 'Je avond leunt naar ' + (MOOD_LABEL[primary] || '').toLowerCase() +
            ', met een vleugje ' + (MOOD_LABEL[secondary] || '').toLowerCase() + '.';
          subEl.removeAttribute('hidden');
        } else {
          subEl.setAttribute('hidden', '');
        }
      }

      var handoffEl = root.querySelector('[data-pl-handoff-link]');
      if (handoffEl) handoffEl.setAttribute('href', primInfo.page);

      var picks = recommend(profile, primary, secondary);
      renderPicks(root, picks);

      hide(quizPanel);
      hide(emailPanel);
      show(resultsPanel);
      scrollToTop();
    }

    // ----- core recommender -----
    function recommend(profile, primary, secondary) {
      var candidates = [];
      var maxScore = Math.max(1, Math.max.apply(null, MOODS.map(function (m) { return profile.scores[m]; })));

      collectCandidates(candidates, catalog[primary], primary, 1.0, profile, maxScore);
      if (secondary && catalog[secondary]) {
        collectCandidates(candidates, catalog[secondary], secondary, 0.6, profile, maxScore);
      }
      // Anal as a cross-pick only for experienced + intense + adventurous profiles.
      var openToAnal = profile.experience >= 3 && profile.intensity >= 3 &&
        (primary === 'bdsm' || secondary === 'bdsm');
      if ((profile.interest.anal || openToAnal) && catalog.anaal) {
        collectCandidates(candidates, catalog.anaal, 'anaal', 0.5, profile, maxScore);
      }

      candidates.sort(function (a, b) { return b.score - a.score; });

      var nPicks = profile.tempo >= 2.5 ? 4 : 3;
      var usedTypes = {};
      var usedHandles = {};
      var chosen = [];

      // Pick a candidate slot: use its curated primary handle, falling back to
      // an alternative if that handle is already taken by another slot.
      function take(cand) {
        if (usedTypes[cand.type]) return null;
        var handle = null;
        for (var i = 0; i < cand.handles.length; i++) {
          if (!usedHandles[cand.handles[i]]) { handle = cand.handles[i]; break; }
        }
        if (!handle) return null;
        usedHandles[handle] = true;
        usedTypes[cand.type] = true;
        var pickType = classify(cand.slotLabel, handle);
        return {
          handle: handle, type: cand.type, candIntensity: cand.candIntensity,
          reason: buildReason(pickType, cand.candIntensity, cand.moodKey, profile)
        };
      }

      candidates.forEach(function (c) {
        if (chosen.length >= nPicks) return;
        var pick = take(c);
        if (pick) chosen.push(pick);
      });

      // Beginner safety net: guarantee at least one gentle pick.
      if (profile.experience <= 1 && chosen.length === nPicks) {
        var soft = chosen.some(function (c) { return c.candIntensity <= 1.5; });
        if (!soft) {
          var gentleCand = candidates.filter(function (c) { return c.candIntensity <= 1.5; })[0];
          if (gentleCand) {
            // free up the last (highest-intensity) slot, then take the gentle one
            var last = chosen[chosen.length - 1];
            delete usedHandles[last.handle]; delete usedTypes[last.type];
            var gentle = take(gentleCand);
            if (gentle) chosen[chosen.length - 1] = gentle;
            else { usedHandles[last.handle] = true; usedTypes[last.type] = true; }
          }
        }
      }

      // Backups for handles that may 404 — any unused handle from remaining slots.
      var backups = [];
      candidates.forEach(function (c) {
        c.handles.forEach(function (h) {
          if (!usedHandles[h] && backups.length < 5 && !backups.some(function (b) { return b.handle === h; })) {
            backups.push({ handle: h, type: c.type, candIntensity: c.candIntensity,
              reason: buildReason(classify(c.slotLabel, h), c.candIntensity, c.moodKey, profile) });
          }
        });
      });

      return { chosen: chosen, backups: backups, nPicks: nPicks };
    }

    function collectCandidates(out, info, moodKey, weight, profile, maxScore) {
      if (!info || !info.slots) return;
      var slots = info.slots;
      var n = slots.length;
      var moodNorm = moodKey === 'anaal' ? 0.5 : (profile.scores[moodKey] || 0) / maxScore;

      slots.forEach(function (slot, idx) {
        if (!slot.handles.length) return;
        var type = classify(slot.label, slot.handles[0]);
        var posFrac = n > 1 ? idx / (n - 1) : 0.5;
        var candInt = clamp(info.base + posFrac * 1.5 - (type === 'care' ? 1.2 : 0), 0, 5);

        var intensityFit = 1 - Math.abs(candInt - profile.intensity) / 5;
        var interestBonus = interestMatch(type, profile.interest);
        var companyFit = (MOOD_AUDIENCE[moodKey] || []).indexOf(profile.company) !== -1 ? 0.3 : 0;

        var gate = 0;
        if ((info.expMin || 0) > profile.experience + 1) gate -= 1.6;       // mood too advanced
        if (candInt > profile.intensity + 2) gate -= 0.9;                   // too intense

        var score =
          weight * (0.45 + 0.55 * moodNorm) +
          0.6 * intensityFit +
          interestBonus +
          companyFit +
          gate +
          (type === 'care' ? -0.25 : 0); // care items support the ritual, not headline picks

        out.push({
          handles: slot.handles.slice(), type: type, slotLabel: slot.label,
          moodKey: moodKey, candIntensity: candInt, score: score
        });
      });
    }

    function renderPicks(root, result) {
      var grid = root.querySelector('[data-pl-picks]');
      if (!grid) return;
      grid.innerHTML = '<div class="pl-vibe__picks-loading">Jouw picks worden geladen…</div>';

      var queue = result.chosen.concat(result.backups);
      var seen = {};
      queue = queue.filter(function (c) { if (seen[c.handle]) return false; seen[c.handle] = true; return true; });

      Promise.all(queue.map(function (c) {
        return fetch('/products/' + c.handle + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (p) { return p ? { product: p, meta: c } : null; })
          .catch(function () { return null; });
      })).then(function (rows) {
        var live = rows.filter(Boolean).slice(0, result.nPicks);
        grid.innerHTML = '';
        if (!live.length) {
          grid.innerHTML = '<div class="pl-vibe__picks-loading">Onze picks zijn even niet beschikbaar. Bezoek een boutique voor persoonlijk advies.</div>';
          return;
        }
        live.forEach(function (row) {
          var p = row.product;
          var card = document.createElement('a');
          card.className = 'pl-vibe__pick';
          card.href = '/products/' + p.handle;
          card.innerHTML =
            '<div class="pl-vibe__pick-img">' +
              '<img src="' + (p.featured_image || '') + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' +
            '</div>' +
            '<div class="pl-vibe__pick-meta">' +
              '<span class="pl-vibe__pick-reason">' + escapeHtml(row.meta.reason) + '</span>' +
              '<h4 class="pl-vibe__pick-title">' + escapeHtml(p.title) + '</h4>' +
              '<p class="pl-vibe__pick-price">' + formatMoney(p.price) + '</p>' +
            '</div>';
          grid.appendChild(card);
        });
      });
    }

    function show(el) { if (el) el.removeAttribute('hidden'); }
    function hide(el) { if (el) el.setAttribute('hidden', ''); }
    function scrollToTop() {
      var top = root.getBoundingClientRect().top + window.pageYOffset - 80;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }
    function escapeHtml(s) {
      return String(s || '').replace(/[&<>"']/g, function (c) {
        return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
      });
    }
    function formatMoney(cents) {
      return '€' + (cents / 100).toFixed(2).replace('.', ',');
    }
  }

  // ----- pure helpers -----
  function clamp(v, lo, hi) { return Math.max(lo, Math.min(hi, v)); }

  function rankMoods(scores) {
    return MOODS.slice().sort(function (a, b) { return scores[b] - scores[a]; });
  }

  function parseCatalog(root) {
    var el = root.querySelector('[data-pl-vibe-catalog]');
    if (!el) return {};
    var raw;
    try { raw = JSON.parse(el.textContent); } catch (e) { return {}; }
    Object.keys(raw).forEach(function (k) {
      raw[k].slots = parseSlots(raw[k].slots);
    });
    return raw;
  }

  // "Label::h1,h2,h3||Label2::h4" -> [{label, handles:[]}]
  function parseSlots(str) {
    if (!str) return [];
    return String(str).split('||').map(function (chunk) {
      var bits = chunk.split('::');
      var label = (bits[0] || '').trim();
      var handles = (bits[1] || '').split(',').map(function (h) { return h.trim(); }).filter(Boolean);
      return { label: label, handles: handles };
    }).filter(function (s) { return s.handles.length; });
  }

  function classify(label, handle) {
    var t = (label + ' ' + handle).toLowerCase();
    if (/glijmiddel|cleaner|reiniger|spritz|pjur|aqua|verzorging|aftercare/.test(t)) return 'care';
    if (/anaal|anal|buttplug|butt-plug|beads|kettting|dildo|plug/.test(t)) return 'anal';
    if (/touw|bondage|boei|cuff|klem|gag|halsband|kraag|collar|riem|tape|restrictie|gesloten|submission|fetish|tepelklem/.test(t)) return 'bondage';
    if (/lingerie|jurk|wetlook|masker|tattoo|lint|braziliaanse/.test(t)) return 'lingerie';
    if (/dice|game|play|spel/.test(t)) return 'spel';
    if (/vibrator|stimulator|wand|massager|duo|rabbit|bullet|balletjes|kegel|balls|ballen|avotap|fay/.test(t)) return 'toy';
    if (/olie|balsem|kaars|aanraking|sfeer|massage|fluwelen/.test(t)) return 'sensory';
    return 'care';
  }

  function interestMatch(type, interests) {
    var map = { sensory: 'sensory', lingerie: 'lingerie', bondage: 'bondage', toy: 'toys', anal: 'anal' };
    var tag = map[type];
    if (!tag) return 0;
    var c = interests[tag] || 0;
    if (c >= 2) return 0.55;
    if (c === 1) return 0.3;
    return 0;
  }

  function buildReason(type, candInt, moodKey, profile) {
    var word = candInt <= 1 ? 'Zacht' : candInt <= 2 ? 'Speels' : candInt <= 3 ? 'Pittig' : candInt <= 4 ? 'Intens' : 'Rauw';
    var tail;
    var typeTag = { sensory: 'sensory', lingerie: 'lingerie', bondage: 'bondage', toy: 'toys', anal: 'anal' }[type];
    if (typeTag && profile.interest[typeTag]) {
      tail = 'jij koos voor ' + INTEREST_LABEL[typeTag];
    } else if ((MOOD_AUDIENCE[moodKey] || []).indexOf(profile.company) !== -1) {
      tail = 'voor ' + (COMPANY_LABEL[profile.company] || 'jou');
    } else {
      tail = 'bij ' + (MOOD_LABEL[moodKey] || '').toLowerCase();
    }
    var base = word + ' — ' + tail;
    if (profile.experience <= 1 && candInt <= 1.5) base = 'Fijn om mee te beginnen — ' + tail;
    return base;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
